import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=e464f3ac&scoped=true&"
import script from "./CategoryModal.vue?vue&type=script&lang=js&"
export * from "./CategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./CategoryModal.vue?vue&type=style&index=0&id=e464f3ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e464f3ac",
  null
  
)

export default component.exports